import { DataTable } from "@constellation-academy/epic-ui";
import { useTranslation } from "@i18n/hooks";
import {
	actionsClass,
	badgeCompatibleClass,
	badgeIncompatibleClass,
} from "./offer-catalogue-table.styles";
import { OfferCatalogueNode, OfferCatalogueTableProps } from "./offer-catalogue-table.types";
import { SubscribeButton } from "../subscribe-button";

export const OfferCatalogueTable = ({ offers, onSubscribed }: OfferCatalogueTableProps) => {
	const { t } = useTranslation("common");

	return (
		<DataTable<OfferCatalogueNode[]>
			value={offers}
			dataKey="offerId"
			emptyMessage={t("offerCatalogue.empty")}
		>
			{(Column) => (
				<>
					<Column header={t("offerCatalogue.columns.offer")} body={(row) => row.title} />
					<Column
						header={t("offerCatalogue.columns.owner")}
						body={(row) => row.owner}
						style={{ width: "10%" }}
					/>
					<Column
						header={t("offerCatalogue.columns.latestVersion")}
						body={(row) => `v${row.latestVersion}`}
						style={{ width: "10%" }}
					/>
					<Column
						header={t("offerCatalogue.columns.compatibility")}
						style={{ width: "20%" }}
						body={(row) => {
							if (row.alreadySubscribed) {
								return (
									<span className={badgeCompatibleClass}>
										{t("offerCatalogue.alreadySubscribed")}
									</span>
								);
							}
							if (row.compatibility.isCompatible) {
								return (
									<span className={badgeCompatibleClass}>
										{t("offerCatalogue.compatible")}
									</span>
								);
							}
							return (
								<span className={badgeIncompatibleClass}>
									{t("offerCatalogue.incompatible", {
										types: row.compatibility.missingElementTypes.join(", "),
									})}
								</span>
							);
						}}
					/>
					<Column
						header={t("table.actions")}
						style={{ width: "12%" }}
						body={(row) => (
							<div className={actionsClass}>
								<SubscribeButton
									offerId={row.offerId}
									alreadySubscribed={row.alreadySubscribed}
									isCompatible={row.compatibility.isCompatible}
									missingElementTypes={row.compatibility.missingElementTypes}
									onSubscribed={onSubscribed}
								/>
							</div>
						)}
					/>
				</>
			)}
		</DataTable>
	);
};
